var exports = {
  "wy": "StaticSplitDiffPreview__RurZaH",
  "H": "splitDiffLines__7fwBuL",
  "XF": "diffTextCell__l50oqr",
  "UG": "diffHunkCell__hd0L3N",
  "$9": "diffHunkText__Tf4_JY",
  "pN": "diffTextInner__yxfpA5",
  "Tc": "diffTextMarker__elRmVD",
  "lW": "syntaxHighlightedAdditionLine__urNBgR",
  "dv": "syntaxHighlightedDeletionLine__hHiJ3g",
  "fr": "diffLineNumber__lZN4BD",
};

module.exports = exports;
